<!-- 目的地区域线路列表 -->
<template>
  <div class="frame destination-region" v-if="region">
    <div class="region-hero">
      <img :src="heroImg" class="region-hero-img" :alt="regionInfo.title" />
      <div class="region-hero-overlay">
        <!-- <span class="region-hero-tag">{{ regionInfo.tag }}</span> -->
        <h1 class="region-hero-title">{{ regionInfo.title }}</h1>
        <!-- <p class="region-hero-sub">{{ regionInfo.sub }}</p> -->
      </div>
    </div>
    <DestinationSection
      :destination-ids="tourIds"
      :title="sectionTitle"
      :label="sectionLabel"
    />
  </div>
</template>

<script>
import DestinationSection from "@/components/DestinationSection.vue";
import {
  getRegionTourIds,
  isValidRegion,
  REGION_HERO_IMGS,
} from "@/utils/destinationRegions";

export default {
  components: { DestinationSection },
  computed: {
    region() {
      return this.$route.params.region;
    },
    tourIds() {
      return getRegionTourIds(this.region);
    },
    heroImg() {
      return REGION_HERO_IMGS[this.region];
    },
    regionInfo() {
      return this.$t(`destinationRegion.regions.${this.region}`);
    },
    sectionLabel() {
      return this.$t("destinationRegion.sectionLabel");
    },
    sectionTitle() {
      return this.$t("destinationRegion.sectionTitle", {
        region: this.regionInfo.title,
      });
    },
  },
  watch: {
    region: {
      immediate: true,
      handler(val) {
        if (!isValidRegion(val)) {
          this.$router.replace("/");
        }
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.destination-region {
  background-color: $box-bg;
}

.region-hero {
  position: relative;
  width: 100%;
  max-height: 420px;
  overflow: hidden;
  line-height: 0;
}

.region-hero-img {
  width: 100%;
  height: 420px;
  object-fit: cover;
  display: block;
}

.region-hero-overlay {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 40px 24px;
  text-align: center;
  background: linear-gradient(
    to bottom,
    rgba(0, 0, 0, 0.35),
    rgba(0, 0, 0, 0.5)
  );
}

.region-hero-tag {
  display: inline-block;
  margin-bottom: 12px;
  padding: 4px 14px;
  font-size: 13px;
  color: #fff;
  border: 1px solid rgba(255, 255, 255, 0.6);
  border-radius: 20px;
  letter-spacing: 1px;
}

.region-hero-title {
  margin: 0 0 16px;
  font-size: 42px;
  font-weight: 700;
  color: #fff;
  line-height: 1.2;
}

.region-hero-sub {
  margin: 0;
  max-width: 720px;
  font-size: 16px;
  line-height: 1.7;
  color: rgba(255, 255, 255, 0.92);
}

@media (max-width: 768px) {
  .region-hero-img {
    height: 280px;
  }

  .region-hero {
    max-height: 280px;
  }

  .region-hero-title {
    font-size: 28px;
  }

  .region-hero-sub {
    font-size: 14px;
  }
}
</style>
